import React from 'react'
import ReactDOM from 'react-dom'
import './assets/css/variables.css'
import './index.css'
import './assets/css/toast.css'
import './assets/css/transitions.css'
import App from './App'
import * as serviceWorker from './serviceWorker'

//Remove console.debug in production
if (process.env.NODE_ENV === 'production') {
  console.debug = () => {}
}

ReactDOM.render(<App />, document.getElementById('root'))

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister()
